import {usersApi as sharedUsersApi} from '@goproblems/shared/api/users';
import {
    BROWSER_DEFAULT_LANGUAGE,
    getBrowserAcceptLanguageHeader,
} from '@utils/language';

export * from '@goproblems/shared/api/users';

const enhancedUsersApi = sharedUsersApi.enhanceEndpoints({
    addTagTypes: ['last-used-collections'],
    endpoints: {
        fetchLastProblemCollectionIds: {
            providesTags: ['last-used-collections'],
        },
        saveLastProblemCollectionId: {
            invalidatesTags: (_result, error) =>
                error ? [] : ['last-used-collections'],
        },
    },
});

export const usersApi = enhancedUsersApi.injectEndpoints({
    endpoints: builder => ({
        setUserProfileSettings: builder.mutation<
            {
                email: string;
                strength: string;
                info: string;
                language: string;
                featuredAchievements: string[];
            },
            {
                email: string;
                strength: string;
                info: string;
                language: string;
                featuredAchievements: string[];
            }
        >({
            query: body => ({
                url: '/me/profile',
                method: 'PATCH',
                body,
                headers:
                    body.language === BROWSER_DEFAULT_LANGUAGE
                        ? {
                              'Accept-Language':
                                  getBrowserAcceptLanguageHeader(),
                          }
                        : undefined,
            }),
            invalidatesTags: ['profile-settings'],
        }),
    }),
});

export const {useSetUserProfileSettingsMutation} = usersApi;
